import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { trustedRedirect, withToken } from '@/utils/redirect'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      alias: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/RegisterPage.vue'),
    },
    {
      path: '/totp',
      name: 'totp',
      component: () => import('@/pages/TotpPage.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/pages/LogoutPage.vue'),
    },
    {
      path: '/oauth/callback',
      name: 'oauth-callback',
      component: () => import('@/pages/OAuthCallbackPage.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/pages/DashboardPage.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/pages/ProfilePage.vue'),
    },
  ],
})

const publicRoutes = ['login', 'register', 'totp']

router.beforeEach(async (to, _from) => {
  const token = localStorage.getItem('auth.token')

  const protectedRoutes = ['dashboard', 'profile']
  if (protectedRoutes.includes(to.name as string) && !token) {
    return { name: 'login' }
  }

  if (publicRoutes.includes(to.name as string) && token) {
    // A token left in the browser is not proof of a session: it may have been revoked or expired.
    // Trusting it sent people round in circles (the app they came from refused it, and sent them
    // back here), so ask the server first and show the form when it says no.
    const { checkToken, logout } = useAuth()
    if (await checkToken() === 'invalid') {
      logout()
      return true
    }

    // Already signed in and sent here by another app: hand the token back, whether the page asked
    // was sign-in or sign-up. Only to an app we trust.
    const target = trustedRedirect(to.query.redirect)
    if (target && (to.name === 'login' || to.name === 'register')) {
      window.location.replace(withToken(target, token))
      return false
    }

    return { name: 'dashboard' }
  }
})

export default router
